import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { ToastService } from './services';

@NgModule({
  imports: [CommonModule],
})
export class SharedToastModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: SharedToastModule,
      providers: [ToastService],
    };
  }
}
